import React, { useEffect, memo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Footer from 'components/Footer2';
import { UserActions } from '../../store/actions/users';
import ModalDadosUser from './Modal/ModalDadosUser';
import Header from '../../components/Header';
import MultiFactorAuth from './MultiFactorAuth';

function User(props) {
  const { me, user } = props;

  const [retry, setRetry] = useState(0);
  useEffect(() => {
    me();
  }, []);

  useEffect(() => {
    if (retry < 3) {
      if (user?._id) {
        setRetry(0);
      } else {
        setRetry((retry) => retry + 1);
      }
    }
  }, [user]);

  return (
    <>
      <Header pagetype="page-inicio" />
      <div className="modUser">
        <ModalDadosUser />
        <MultiFactorAuth />
      </div>
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  company: state.companies.company,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(User))
);
